import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class ViewFactoryLoadingMessage extends Message {

    public name: string;

    public constructor(params: any) {
        super(params);

        this.name = this.paramOrDefault(params.name, null);
    }
}

ComponentManager.setMessage('ViewFactoryLoadingMessage', ViewFactoryLoadingMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');